import { useEffect, useRef } from "react";

const EMPTY_ARRAY: readonly any[] = [];

/**
 * Run the given function when component unmount.
 * This is copied from Mobx.
 * https://github.com/mobxjs/mobx-react-lite/blob/master/src/utils.ts
 *
 * please also modify useUnmount in packages/core-utilities/src/hooks.ts
 * when you modify this function. Scenario: https://microsoft.visualstudio.com/OS/_workitems/edit/41542542
 *
 * @param fn The function will be run when component unmount.
 */
export const useUnmount = (fn: () => void) => {
    useEffect(() => fn, EMPTY_ARRAY);
};

/**
 * Run the function only one when component mounted (BEFORE 1st render).
 * This is in contrast to useEffect which runs only _after_ the first
 * render (and of course, whenever something in it's dependency array
 * forces it to run again).
 *
 * please also modify useMount in packages/core-utilities/src/hooks.ts
 * when you modify this function. Scenario: https://microsoft.visualstudio.com/OS/_workitems/edit/41542542
 *
 * @param fn The fuction will run only once when component is mounted.
 */
export const useMount = (fn: () => Promise<any> | void): void => {
    // We are using Ref to avoid and race condition.
    const init = useRef<boolean>(false);
    if (!init.current) {
        // Only run this once at the begining
        init.current = true;
        fn();
    }
};
